import lozad from "lozad";

try {
  const observer = lozad('.lozad', {
    loaded(el) {
      $(el)
        .addClass('is-loaded')
        .trigger('lozad-loaded')
    }
  }); // lazy loads elements with default selector as '.lozad'

  observer.observe();
} catch (e) {
  $('.lozad').each(function(){
    $(this).attr('src', $(this).data('src') )
    $(this).addClass('is-loaded')
    $(this).trigger('lozad-loaded')
  })
}
